import { cn } from '../../lib/utils'
import type { BranchTreeGuide } from './branch-tree'

interface BranchTreeGuidesProps {
  guides: BranchTreeGuide[]
  /** Extra classes on the container, e.g. negative margins to span a padded row. */
  className?: string
}

/**
 * Draws a branch row's indent guides as thin full-height lines (one
 * fixed-width cell per nesting level), so the verticals connect across
 * adjacent rows the way an IDE file tree does — unlike text glyphs, which
 * only span the line-height and leave gaps in tall rows. Place inside the
 * row's flex container before the row icon; stretches to the row height.
 */
export function BranchTreeGuides({ guides, className }: BranchTreeGuidesProps) {
  if (guides.length === 0) return null
  return (
    <span aria-hidden className={cn('flex shrink-0 self-stretch', className)}>
      {guides.map((guide, i) => (
        <span key={i} className="relative w-4">
          {guide === 'pipe' || guide === 'tee' ? (
            <span className="absolute inset-y-0 left-1/2 w-px bg-line" />
          ) : null}
          {guide === 'corner' ? (
            <span className="absolute top-0 bottom-1/2 left-1/2 w-px bg-line" />
          ) : null}
          {guide === 'tee' || guide === 'corner' ? (
            <span className="absolute top-1/2 right-0 left-1/2 h-px bg-line" />
          ) : null}
        </span>
      ))}
    </span>
  )
}
